// This file can be replaced during build by using the `fileReplacements` array.
// `ng build --prod` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.

export const environment = {
  production: false,
  // Service: {
  //   EngajeLoginApiBaseUrl: "https://api.engaje.app/engaje/",
  //   EngajeBusinessApiBaseUrl: "https://api.engaje.app/engajecommerce/",
  //   ImageBaseUrl: 'https://api.engaje.app/adimage/',
  //   deviceUrl: 'https://demoscan.engaje.app/init/',
  //   // EngajeLoginApiBaseUrl: "https://192.168.1.42:6021/engaje/",
  //   // EngajeBusinessApiBaseUrl: "https://192.168.1.42:6024/engajecommerce/",
  //   AuthBaseUrl: 'https://api.engaje.app/',
  //   stripeKey: 'pk_test_UlbCJanWCtA6meEtmqJjghIt00ezxM7PRd'
  // }
  Service: {
    EngajeLoginApiBaseUrl: "https://dev.engaje.app/engaje/",
    EngajeBusinessApiBaseUrl: "https://dev.engaje.app/engajecommerce/",
    ImageBaseUrl: 'https://dev.engaje.app/adimage/',
    deviceUrl: 'https://devscan.engaje.app/init/',
    // EngajeLoginApiBaseUrl: "https://192.168.1.48:6021/engaje/",
    // EngajeLoginApiBaseUrl: "https://localhost:6021/engaje/",
    // EngajeBusinessApiBaseUrl: "https://192.168.1.44:6024/engajecommerce/",
    AuthBaseUrl: 'https://dev.engaje.app/',
    stripeKey: 'pk_test_UlbCJanWCtA6meEtmqJjghIt00ezxM7PRd',
    queueUserId: {
      sangam: '915',
      a2b: '873',
      yummy: '857',
      htland: '940',
      vp: '571'
    }
  }
  // Service: {
  //   EngajeLoginApiBaseUrl: "https://demo.engaje.app/engaje/",
  //   EngajeBusinessApiBaseUrl: "https://demo.engaje.app/engajecommerce/",
  //   ImageBaseUrl: 'https://demo.engaje.app/adimage/',
  //   deviceUrl: 'https://demoscan.engaje.app/init/',
  //   // EngajeLoginApiBaseUrl: "https://192.168.1.33:6021/engaje/",
  //   // EngajeBusinessApiBaseUrl: "https://192.168.1.33:6024/engajecommerce/",
  //   AuthBaseUrl: 'https://demo.engaje.app/',
  //   stripeKey: 'pk_test_UlbCJanWCtA6meEtmqJjghIt00ezxM7PRd'
  // }
  // Service: {
  //   EngajeLoginApiBaseUrl: "https://meatlovers.engaje.app/engaje/",
  //   EngajeBusinessApiBaseUrl: "https://meatlovers.engaje.app/engajecommerce/",
  //   ImageBaseUrl: 'https://meatlovers.engaje.app/adimage/',
  //   // ImageBaseUrl: 'https://192.168.1.41:5005/adimage/',
  //   deviceUrl: 'https://meatlovers.engaje.app/init/',
  //   // EngajeLoginApiBaseUrl: "https://192.168.1.37:6021/engaje/",
  //   // EngajeLoginApiBaseUrl: "https://localhost:6021/engaje/",
  //   // EngajeBusinessApiBaseUrl: "https://192.168.1.33:6024/engajecommerce/",
  //   AuthBaseUrl: 'https://meatlovers.engaje.app/',
  //   stripeKey: 'pk_test_UlbCJanWCtA6meEtmqJjghIt00ezxM7PRd'
  // }
};

/*
 * For easier debugging in development mode, you can import the following file
 * to ignore zone related error stack frames such as `zone.run`, `zoneDelegate.invokeTask`.
 *
 * This import should be commented out in production mode because it will have a negative impact
 * on performance if an error is thrown.
 */
// import 'zone.js/plugins/zone-error';  // Included with Angular CLI.
